import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const SessionSelection = ({ onSessionChange, disabled }) => {
  const handleChange = (e) => {
    onSessionChange(e.target.value);
  };

  return (
    <FormControl
      fullWidth
      variant="outlined"
      sx={{ marginTop: "1em", width: "50%" }}
    >
      <InputLabel id="sessionType">Session Type</InputLabel>
      <Select
        labelId="sessionType"
        label="Session Type"
        onChange={handleChange}
        disabled={disabled}
      >
        <MenuItem value="">
          <em>--Please choose an option--</em>
        </MenuItem>
        <MenuItem value="morning">Morning</MenuItem>
        <MenuItem value="afternoon">Afternoon</MenuItem>
        <MenuItem value="full day">Full Day</MenuItem>
      </Select>
    </FormControl>
  );
};

export default SessionSelection;
